import React from "react";
import { useTranslation } from "react-i18next";
import { withSelectedResult } from "../../../providers/ResultSelectContext";
import OmronPagingInfo from "../PagingInfo/PagingInfo";

function SearchAllResults({
  isAllResultSelected,
  setIsAllResultsSelected,
  resetAllSelected,
}) {
  const { t } = useTranslation();
  return (
    <div className="u-flex u-flex--between u-font--s u-mt30">
      <p className="u-form-label">
        <input
          type="checkbox"
          id="select-all"
          checked={isAllResultSelected}
          onChange={() => {
            if (isAllResultSelected) {
              resetAllSelected();
            } else {
              setIsAllResultsSelected(!isAllResultSelected);
            }
          }}
        />
        <label htmlFor="select-all">{t("Select all search results")}</label>
      </p>
      <p className="u-font--bold">
        <OmronPagingInfo />
      </p>
    </div>
  );
}

const mapContextToProps = ({
  isAllResultSelected,
  setIsAllResultsSelected,
  resetAllSelected,
}) => ({
  isAllResultSelected,
  setIsAllResultsSelected,
  resetAllSelected,
});
export default withSelectedResult(mapContextToProps)(SearchAllResults);
